export const IDENTITY_CARD_ID = 2;
export const ABOUT_CARD_ID = 3;
export const PORTFOLIO_CARD_ID = 4;
export const APPROACH_CARD_ID = 5;
export const CONTACT_CARD_ID = 6;
